import logo from './logo.svg';
import './App.css';
import { Outlet } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from 'react';
import { summaryApi } from './common';
import Context from './context';
import { useDispatch } from 'react-redux';
import { setUserDetails } from './store/userSlice';
import ThemeProvider from './components/Theme/ThemeProvider';
import { useTheme } from './components/Theme/ThemeProvider';
import { authFetch } from './helpers/authFetch';

// AppContent component - uses useTheme hook
const AppContent = () => {
  const dispatch = useDispatch();
  const [cartCount, setCartCount] = useState(0);
  const { colors } = useTheme(); // Safe to use here - inside ThemeProvider

  const fetchUserDetails = async () => {
    const response = await authFetch(summaryApi.current_user.url, {
      method: summaryApi.current_user.method,      
    });

    const responseData = await response.json();

    if (responseData.success) {
      dispatch(setUserDetails(responseData.data))
    }
  }

  const fetchUserAddToCart = async () => {
    try {
      const response = await authFetch(summaryApi.cartCounter.url, {
        method: summaryApi.cartCounter.method,
        
      });
      
      const responseData = await response.json();
      const cartCount = responseData?.data?.count || responseData?.count || 0;
      setCartCount(cartCount);

    } catch (error) {
      console.error("Cart Counter Error:", error);
      setCartCount(0);
    }
  }

 useEffect(() => {
  const token = localStorage.getItem("token");
  if (token) {
    fetchUserDetails();
    fetchUserAddToCart();
  }
}, []);// eslint-disable-next-line

  return (
    <div 
      className="min-h-screen transition-colors duration-300"
      style={{ 
        backgroundColor: colors.bg,
        color: colors.text 
      }}
    >
      <Context.Provider value={{
        fetchUserDetails,
        cartCount,
        fetchUserAddToCart
      }}>
        <ToastContainer
          theme="colored"
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <Header />
        <main className='min-h-[calc(100vh-100px)] pt-16'>
          <Outlet />
        </main>
        <Footer />
      </Context.Provider>
    </div>
  );
};

// App component - wraps AppContent with ThemeProvider
function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;